// extracted by mini-css-extract-plugin
module.exports = {"root":"IconPerson_root__1ajC9"};